Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    box = _STYLES$useStyles.box,
    colors = _STYLES$useStyles.colors,
    spacing = _STYLES$useStyles.spacing,
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    bp = _STYLES$useStyles.bp,
    viewports = _STYLES$useStyles.viewports;
  var container = Object.assign({}, box, {
    alignItems: 'center',
    position: 'relative',
    paddingHorizontal: spacing.s,
    justifyContent: 'center'
  });
  if (bp.gt(viewports.mobile_s)) {
    container.paddingHorizontal = spacing.l;
  }
  if (bp.gt(viewports.mobile_normal)) {
    container.paddingHorizontal = spacing.xl;
  }
  var value = Object.assign({}, fontBold, {
    color: colors.alternative,
    fontSize: _styles.STYLES.fontSize.xxl,
    lineHeight: _styles.STYLES.lineHeight.xxl
  });
  var label = Object.assign({}, fontRegular, {
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.normal,
    textAlign: 'center'
  }, _reactNative.Platform.select({
    web: {
      wordBreak: 'break-word'
    }
  }));
  if (bp.gt(viewports.tablet)) {
    label.textAlign = 'left';
  }
  var imageContainer = {};
  if (bp.gt(viewports.tablet)) {
    imageContainer.marginTop = spacing.xs;
    imageContainer.marginRight = spacing.s;
  }
  var image = {
    width: '100%',
    height: '100%'
  };
  var valueContainer = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    justifyContent: 'center'
  };
  if (bp.gt(viewports.tablet)) {
    container.paddingHorizontal = spacing.xl;
    container.flexDirection = 'row';
    valueContainer.justifyContent = 'flex-start';
  }
  var valueUnit = Object.assign({}, fontBold, {
    color: colors.alternative,
    fontSize: _styles.STYLES.fontSize.m,
    lineHeight: _styles.STYLES.lineHeight.m
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    value: value,
    label: label,
    imageContainer: imageContainer,
    image: image,
    valueContainer: valueContainer,
    valueUnit: valueUnit
  });
  return {
    styles: styles
  };
};